import { CSS, styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { TextareaHTMLAttributes, forwardRef, useContext } from "react";
import { FieldContext } from "./Field";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  css?: CSS;
  onValueChange?: (value: string) => void;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { onValueChange, ...props },
  ref,
) {
  const { inputProps } = useContext(FieldContext);
  return (
    <Root
      {...inputProps}
      {...props}
      onChange={e => {
        props.onChange?.(e);
        if (!e.defaultPrevented) {
          onValueChange?.(e.target.value);
        }
      }}
      ref={ref}
    />
  );
});

const Root = styled("textarea", {
  minW: 0,
  w: "100%",
  border: "1px solid",
  borderColor: colors.outline,
  backgroundColor: colors.transparent,
  rounded: 8,
  py: 8,
  px: 12,
  "&:focus-visible": {
    outline: "none",
    borderColor: colors.blue500,
    boxShadow: `0 0 0 1px ${colors.blue500}`,
  },
  "&::placeholder": {
    color: colors.text3,
  },
});
